import React, { memo, useCallback } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import Logo from "../Logo";
import Marquee from "../Marquee";
import styles from "./Header.module.css";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { useAuth } from "../../contexts/JWTContext";

const Header = memo(({ onLoginClick, onContactClick, onRegisterClick }) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const playerBalance = useSelector((state) => state.user.playerBalance);
  const playerCash = useSelector((state) => state.user.playerCash);
  const { logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isMenuPage = location.pathname === "/menu";

  const handleLogin = useCallback(() => {
    onLoginClick();
  }, [onLoginClick]);

  const handleRegister = useCallback(() => {
    if (onRegisterClick) {
      onRegisterClick();
    }
  }, [onRegisterClick]);

  const openMenuWithTab = useCallback(
    (tabId) => {
      if (!isAuthenticated) {
        if (onLoginClick) onLoginClick();
        return;
      }
      navigate(`/menu?tab=${tabId}`);
    },
    [isAuthenticated, navigate, onLoginClick],
  );

  const openMenuList = useCallback(() => {
    if (!isAuthenticated) {
      if (onLoginClick) onLoginClick();
      return;
    }
    navigate("/menu");
  }, [isAuthenticated, navigate, onLoginClick]);

  const menuPlayTextColor = "var(--mainText, #ffffff)";

  // ensure header logout clears storage like footer
  const handleLogout = useCallback(() => {
    try {
      logout();
    } catch (e) {
      console.error("Logout error:", e);
    }
    try {
      localStorage.removeItem("user");
      localStorage.removeItem("userId");
      localStorage.removeItem("token");
      localStorage.removeItem("authToken");
      localStorage.removeItem("persist:root");
      localStorage.clear();
      sessionStorage.clear();
    } catch (e) {
      // ignore
    }
    // redirect to home
    window.location.href = "/";
  }, [logout]);

  return (
    <header className={styles.header}>
      <div className={styles.topBar}>
        <div className={styles.container}>
          <div className={styles.leftSection}>
            <div className={styles.logoWrapper}>
              <Logo size="medium" />
            </div>
          </div>

          <div className={styles.center2Section}>
            {!currentUser && (
              <div className={styles.authSection}>
                <div className={styles.authButtons}>
                  <button className={styles.loginBtn} onClick={handleLogin}>
                    เข้าสู่ระบบ
                  </button>

                  <button
                    className={styles.registerBtn}
                    onClick={handleRegister}
                  >
                    สมัครสมาชิก
                  </button>
                </div>
              </div>
            )}
            {currentUser && !isMenuPage ? (
              <div className={styles.userBox}>
                <div className={styles.userInfo}>
                  <div className={styles.userAvatar}>
                    <Icon
                      icon="solar:user-circle-bold-duotone"
                      width={32}
                      height={32}
                    />
                  </div>
                  <div className={styles.userDetails}>
                    <span className={styles.username}>
                      {currentUser?.username || currentUser?.name || "ผู้ใช้"}
                    </span>
                  </div>
                </div>

                <div className={styles.userStats}>
                  <div className={styles.statItem}>
                    <div className={`${styles.iconBox} ${styles.balanceIcon}`}>
                      <Icon
                        icon="solar:wallet-money-bold-duotone"
                        width={25}
                        height={25}
                      />
                    </div>
                    <div
                      className={`${styles.statInfo} ${styles.statInfoLeft}`}
                    >
                      <span className={styles.statLabel}>เครดิต</span>
                      <span className={styles.statValue}>
                        {Number(playerBalance || 0).toLocaleString()}
                      </span>
                    </div>
                  </div>

                  {/*}  <div className={styles.statItem}>
                    <div className={`${styles.iconBox} ${styles.pointIcon}`}>
                      <Icon
                        icon="streamline-plump-color:wallet-flat"
                        width={25}
                        height={25}
                      />
                    </div>
                   ≈}  <div
                      className={`${styles.statInfo} ${styles.statInfoLeft}`}
                    >
                      <span className={styles.statLabel}>เงินสด</span>
                      <span className={styles.statValue}>
                        {Number(playerCash || 0).toLocaleString()}
                      </span>
                    </div>
                  </div>*/}

                  {/*<div className={styles.statItem}>
                    <div className={`${styles.iconBox} ${styles.pointIcon}`}>
                      <Icon
                        icon="ri:copper-diamond-fill"
                        width={25}
                        height={25}
                      />
                    </div>
                    <div className={styles.statInfo}>
                      <span className={styles.statLabel}>เพชร</span>
                      <span className={styles.statValue}>
                        {Number(wheelPoint || 0).toLocaleString()}
                      </span>
                    </div>
                  </div>*/}
                </div>

                <button
                  className={styles.logoutBtn}
                  onClick={handleLogout}
                  aria-label="Logout"
                >
                  <Icon
                    icon="solar:logout-2-bold-duotone"
                    width={24}
                    height={24}
                  />
                </button>
              </div>
            ) : null}
          </div>

          <div className={styles.rightSection}>
            {isMenuPage && (
              <button
                type="button"
                className={styles.menuPlayBtn}
                onClick={() => navigate("/slot")}
                style={{ color: menuPlayTextColor }}
              >
                <Icon
                  icon="mdi:cards-playing"
                  width={18}
                  height={18}
                  style={{ color: menuPlayTextColor }}
                />
                <span
                  className={styles.menuPlayBtnText}
                  style={{ color: menuPlayTextColor }}
                >
                  เข้าเล่นเกม
                </span>
              </button>
            )}
            <div>
              <button
                type="button"
                className={styles.edgeBtn}
                aria-label="Menu"
                onClick={openMenuList}
              >
                <Icon icon="material-symbols:menu" width={26} height={26} />
              </button>
            </div>
          </div>
        </div>
      </div>

      {!isMenuPage && (
        <div className={styles.announceBar}>
          <div className={styles.container}>
            <div className={styles.announceLabel}>ประกาศ:</div>
            <div className={styles.announceMarquee}>
              <Marquee variant="header" />
            </div>
          </div>
        </div>
      )}
    </header>
  );
});

Header.displayName = "Header";

export default Header;
